import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchActualAndProjectedSettlements = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.actualAndProjectedSettlements;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadActualSettlementsReport = (retailerId, locale) => {
  const { url } = DepsService.rest.widgets.instant.settlements.downloadReport;
  const queryParams = {
    locale,
  };
  const urlParams = {
    retailerId,
  };
  const headers = { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/actual-and-projected-settlements.api.js